import React from "react";
import {
  Container,
  Segment,
  Statistic,
  Icon,
  Image,
} from "semantic-ui-react";
import type {
  SemanticCOLORS,
  StatisticGroupProps
} from "semantic-ui-react";
import { getImageUrl } from "../../../utils/images";


type StatisticSize = StatisticGroupProps["size"];

interface StatisticItem {
  value: string | number;
  label?: string;
  icon?: string;
  image?: string;
  color?: SemanticCOLORS;
}

interface StatisticsData {
  horizontal?: boolean;
  inverted?: boolean;
  size?: StatisticSize;
  items?: StatisticItem[];
}

interface StatisticsViewProps {
  data: StatisticsData;
}


const StatisticsView = ({ data = {} }: StatisticsViewProps) => {
  const {
    horizontal = false,
    inverted = false,
    size = 'small',
    items = [],
  } = data;

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="statistics-view">
      <Container>
        <Segment basic={!inverted} inverted={inverted}>
          <Statistic.Group horizontal={horizontal} size={size}>
            {items.map((item, index) => {
              const imageUrl = item.image
                ? getImageUrl(item.image)
                : undefined;

              return (
                <Statistic
                  key={index}
                  inverted={inverted}
                  color={item.color as any}
                >
                  <Statistic.Value>
                    {item.icon && <Icon name={item.icon as any} />}

                    {imageUrl && (
                      <Image
                        src={imageUrl}
                        inline
                        circular
                      />
                    )}

                    {item.value}
                  </Statistic.Value>

                  {item.label && (
                    <Statistic.Label>{item.label}</Statistic.Label>
                  )}
                </Statistic>
              );
            })}
          </Statistic.Group>
        </Segment>
      </Container>
    </div>
  );
};

export default StatisticsView;